import { useEffect } from 'react';
import { siteUrl } from '../constants/site';

interface SEOProps {
    title: string;
    description: string;
    canonical: string;
    ogImage?: string;
}

export const useSEO = ({ title, description, canonical, ogImage = siteUrl('/assets/visuals/og-image-v3.png') }: SEOProps) => {
    useEffect(() => {
        // Update title
        document.title = title;

        // Helper to update or create meta tag
        const setMetaTag = (attribute: string, value: string, content: string) => {
            let element = document.querySelector(`meta[${attribute}="${value}"]`);
            if (!element) {
                element = document.createElement('meta');
                element.setAttribute(attribute, value);
                document.head.appendChild(element);
            }
            element.setAttribute('content', content);
        };

        // Helper to update or create link tag
        const setLinkTag = (rel: string, href: string) => {
            let element = document.querySelector(`link[rel="${rel}"]`);
            if (!element) {
                element = document.createElement('link');
                element.setAttribute('rel', rel);
                document.head.appendChild(element);
            }
            element.setAttribute('href', href);
        };

        // Primary meta tags
        setMetaTag('name', 'description', description);
        setMetaTag('name', 'title', title);

        // Canonical
        setLinkTag('canonical', canonical);

        // Open Graph
        setMetaTag('property', 'og:title', title);
        setMetaTag('property', 'og:description', description);
        setMetaTag('property', 'og:url', canonical);
        setMetaTag('property', 'og:image', ogImage);

        // Twitter
        setMetaTag('name', 'twitter:title', title);
        setMetaTag('name', 'twitter:description', description);
        setMetaTag('name', 'twitter:url', canonical);
        setMetaTag('name', 'twitter:image', ogImage);
    }, [title, description, canonical, ogImage]);
};
